import {Injectable} from '@angular/core';

@Injectable()
export class PropertiesService {

	properties: any = {};

	constructor() {
	}

	set(key: string, value: any): void {
		this.properties[key] = value;
	}

	get (key: string): any {
		return this.has(key) ? this.properties[key] : null;
	}

	has (key: string): boolean {
		return this.properties.hasOwnProperty(key);
	}
}



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/Services/properties.service.ts